import img_checked from '@/assets/img/img_checked.png';
import img_uncheck from '@/assets/img/img_uncheck_v2.png';

const CheckBox = ({
  children,
  className,
  style,
  server_list,
  value,
  onClick,
}) => {
  return (
    <span onClick={onClick} className={`${className} cursor-pointer`} style={style}>
      <img
        
        className="w-16px mr-12px"
        src={server_list?.includes(value) ? img_checked : img_uncheck}
      />
      {children}
    </span>
  );
};

export default CheckBox;
